module.exports = __webpack_public_path__ + "static/picwords-ipad-sketch-5a75e3e826c75bf59097e88f78c93421.png";